<template>
    <div>
        <div>
            <p class="color1 text-2xl text-center">Evaluación de {{datos.libro}}</p>
            <vs-divider></vs-divider>
            <p class="mt-3"><b class="color1">Disponible: </b> {{ setEvaluacion.fecha_inicio }} - {{ setEvaluacion.fecha_fin }}</p>
            <div class="flex mt-2">
                <span class="mr-3"><b class="color1">Puntos: </b> {{ setEvaluacion.puntaje }}</span>
                <span><b class="color1">Límite de tiempo: </b> {{ setEvaluacion.tiempo }} minutos</span>
            </div>
            <p class="mt-5 color2 tamanio1">
                <b>Indicaciones del profesor/a:</b> {{ setEvaluacion.indicaciones }}
            </p>
            <vs-divider class="mt-3"></vs-divider>
            <div class="vx-row">
                <div class="vx-col w-full sm:w-full md:w-1/2 lg:w-5/6 xl:w-5/6 mb-6">
                    <div class="vx-row" v-for="(item,key) in arrayQuestions" :key="key">
                        <div class="vx-col w-full mb-6">
                            <div class="flex bg1" style="justify-content: space-between;">
                                <p class="bg1 titulo">Pregunta {{ key + 1 }} <small style="font-size: 10px;" v-if="item.id_tipo == idPreguntaMultiple">( Puede aver varias opciones de respuesta )</small></p>
                                <p class="bg1 titulo">{{ item.puntaje }} pts</p>
                            </div>
                            <div class="inline-block mr-4"> <Voces :datosVoz="item" :accionVoz="1" /> </div>
                            <div class="inline-block mt-5">{{ item.pregunta }}</div>
                            <!--imagen-->
                            <img @click="urlImagen=item.url;popupVerImagen = true;" v-if="item.url!='' && item.url!='null' && item.url!=null" :src="$data_book+'archivos/'+'preguntas'+'/'+item.url" class="img-responsive mt-5 cursor-pointer" width="200" height="200" style="border-radius: 5px;">
                            <!-- <img v-if="item.imagen != null" :src="item.imagen" alt="imagen" class="w-full mt-5"> -->
                            <!--opciones-->
                            <br>
                            <vs-divider></vs-divider>
                            <!--pregunta abierta-->
                            <div v-if="item.id_tipo == idPreguntaAbierta">
                                <!--INPUT-->
                                <vs-input v-model="item.seleccionar" @blur="selectPreguntaAbierta(item)" class="w-full mt-5" label="Respuesta" placeholder="Escribe tu respuesta aquí"></vs-input>
                            </div>
                            <!--pregunta columna-->
                            <div v-else-if="item.id_tipo == idPreguntaColumna">
                                <table style="width: 100%;" v-if="item.opciones.length > 0">
                                    <tr>
                                        <th>{{ item.columna1 }}</th>
                                        <th >{{ item.columna2 }}</th>
                                    </tr>
                                    <tr v-for="(tr, indexitem) in item.opciones" :key="indexitem" >
                                        <td><b>{{ indexitem + 1 }}.</b> {{ tr.respuesta }}</td>
                                        <td style="background-color: #f6f6f6;width: 40%;">
                                            <v-select :options="item.respuestasColumna" @input="calificarPreguntaColumna(item,tr)" :reduce="val => val" class="w-full my-1" v-model="tr.seleccionar" />
                                        </td>
                                    </tr>
                                </table>
                            </div>
                            <!--preguntas multiples-->
                            <div v-else-if="item.id_tipo == idPreguntaMultiple">
                                <ul class="leftx" v-for="(tr,key2) in item.opciones" :key="key2">
                                    <li class="my-2">
                                        <vs-checkbox  @input="calificarPreguntaMultiple(item)" v-model="tr.seleccionar" color="success">{{ tr.respuesta }}</vs-checkbox>
                                    </li>
                                </ul>
                            </div>
                            <div v-else>
                                 <!--preguntas normales-->
                                <ul class="leftx" v-for="(tr,key2) in item.opciones" :key="key2">
                                    <li class="my-2" style="font-size:15px;">
                                        <input 
                                            style="transform: scale(1.2);
                                            margin-right: 10px;"
                                            type="radio" 
                                            :id="'pregunta_' + item.id + '_' + tr.respuesta" 
                                            :name="'radios1_' + tr.id_pregunta" 
                                            :value="tr.respuesta" 
                                            :v-model="'pregunta'+item.id"
                                            @input="calificarPregunta(item, tr, key)" 
                                        />
                                        <label style="position: relative;top:1px;" :for="'pregunta_' + item.id + '_' + tr.respuesta"> {{ tr.respuesta }}</label>
                                        <!-- <input type="radio" id="huey" name="drone" value="huey" />
                                        <vs-radio :v-model="'pregunta'+item.id" @input="calificarPregunta(item,tr,key)" :vs-name="'radios1'+tr.id_pregunta" :vs-value="tr.respuesta">{{ tr.respuesta }}</vs-radio> -->
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <vs-divider></vs-divider>
                </div>
                <div class="vx-col w-full sm:w-full md:w-1/2 lg:w-1/6 xl:w-1/6 mb-6">
                    <p>
                        <!--RELOJ-->
                        <i class="fa-solid fa-clock"></i> <span id="demo" class="color1 reloj mt-5 mb-4"> </span>
                    </p>
                    <br/>
                    <p class="text-center font-semibold color1">Preguntas</p>
                    <!--listado ul de preguntas arrayQuestions-->
                    <ul class="leftx">
                        <li v-for="(item, key) in arrayQuestions" :key="key" class="my-2">
                            <button @click="scrollTo(item.id)" :class="'tipo' + item.id + ' w-full colorbase'">
                                <i class="fa-regular fa-circle-question"></i> Pregunta {{ key + 1 }}
                            </button>
                        </li>
                    </ul>
                    <br>
                    <!--boton de finalizar evaluacion-->
                    <vs-button @click="openConfirmFinalizar()" icon="check" class="w-full mt-5" type="gradient" color="success">Finalizar Evaluación</vs-button>
                </div>
            </div>
        </div>
        <!--modales-->
        <!--modal para ver imagen-->
        <vs-popup class="holamundo" title="" fullscreen :active.sync="popupVerImagen">
            <div v-if="popupVerImagen">
                <div class="flex" style="justify-content: center;">
                    <image-zoom
                        :regular="$data_book+'archivos/'+'preguntas'+'/'+urlImagen"
                        :zoom-amount="3"
                        :click-zoom="true"
                        click-message="De click para aumentar"
                        img-class="img-fluid"
                        >
                    </image-zoom>
                </div>
            </div>
        </vs-popup>
    </div>
</template>
<script>
  import {
    mapState
} from "vuex";
import vSelect from 'vue-select'
import imageZoom from 'vue-image-zoomer';
import Voces from "../../games/componentes/voces.vue";
export default {
    components:{
        vSelect,
        imageZoom,
        Voces
    },
    data() {
        return{
            nombreasignatura:'',
            idPreguntaMultiple:8,
            idPreguntaAbierta:7,
            idPreguntaColumna:5,
            arrayQuestions:[],
            fecha:'',
            intervalId: null, // Variable para almacenar el identificador del intervalo,
            popupVerImagen:false,
            urlImagen:'',
        }
    },
    computed: {
        ...mapState(['setEvaluacion'])
    },
    props:{
        datos:{
            type:Object,
            default:()=>({})
        },
        arrayPreguntas:{
            type:Array,
            default:()=>([])
        },
        evaluacionEstudiante:{
            type:Object,
            default:()=>({})
        }
    },
    mounted(){
        let me  = this 
        me.nombreasignatura = localStorage.getItem("nombreasignatura")
        me.arrayQuestions   = me.arrayPreguntas
        //limpiar el reloj
        document.getElementById("demo").innerHTML = ""
        setTimeout(this.ejecutar, 1000);
    },
    methods:{
        selectPreguntaAbierta(item){
            let me = this
            if(item.seleccionar == null || item.seleccionar == ''){
                //si esta vacio restablezco el color base
                let element = document.querySelector('.tipo'+item.id)
                element.classList.remove('colorbase')
                element.classList.add('colorSeleccionado')
            }else{
                //pintar el ultimo boton 
                let element = document.querySelector('.tipo'+item.id)
                element.classList.remove('colorbase')
                element.classList.add('colorSeleccionado')
            }
        },
        calificarPreguntaMultiple(item){
            let me = this
            let element = document.querySelector('.tipo'+item.id)
            element.classList.remove('colorbase')
            element.classList.add('colorSeleccionado')
            //SOLO enviar del item el id, la respuesta y seleccionar
            let datosEnvar = []
            item.opciones.forEach(element => {
                //si seleccionar es true envio true con "true" y si es false envio false con "false
                let resSend = element.seleccionar == true ? "true" : "false"
                var cal = new Object()
                cal.id          = element.id
                cal.respuesta   = element.respuesta
                cal.seleccionar = resSend
                datosEnvar.push(cal)
            });
            let formData = new FormData();
            formData.append('id_evaluacion',            this.setEvaluacion.id);
            formData.append('id_intento',               this.evaluacionEstudiante.id_evaluacion_estudiante);
            formData.append('id_estudiante',            this.evaluacionEstudiante.id_estudiante);
            formData.append('id_pregunta',              item.id);
            formData.append('arrayRespuestas',          JSON.stringify(datosEnvar));
            formData.append('calificarPreguntaMultiple','1')
            this.$http.post(this.$server_url+'evaluacionEstudiante', formData)
            .then(res => {
                if(res.data.status == 0){
                    this.$vs.notify({
                        title: 'Error',
                        text: res.data.message,
                        color: 'danger',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle'
                    })
                }
            })
        },
        calificarPreguntaColumna(item,tr){
            let me = this
            let element = document.querySelector('.tipo'+item.id)
            element.classList.remove('colorbase')
            element.classList.add('colorSeleccionado')
            //SOLO enviar del item el id, la respuesta y seleccionar
            let datosEnvar = []
            item.opciones.forEach(element => {
                var cal = new Object()
                cal.id = element.id
                cal.respuesta = element.respuesta
                cal.seleccionar = element.seleccionar
                datosEnvar.push(cal)
            });
            let formData = new FormData();
            formData.append('id_evaluacion',            this.setEvaluacion.id);
            formData.append('id_intento',               this.evaluacionEstudiante.id_evaluacion_estudiante);
            formData.append('id_estudiante',            this.evaluacionEstudiante.id_estudiante);
            formData.append('id_pregunta',              item.id);
            formData.append('arrayRespuestas',          JSON.stringify(datosEnvar));
            formData.append('calificaPreguntaColumna',  '1')
            this.$http.post(this.$server_url+'evaluacionEstudiante', formData)
            .then(res => {
                if(res.data.status == 0){
                    this.$vs.notify({
                        title: 'Error',
                        text: res.data.message,
                        color: 'danger',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle'
                    })
                }
            })
        },
        calificarPregunta(item,tr){
            //quitar la clase colorbase al boton tipo y agregar la clase colorSeleccionado con classlist y remove la clase colorbase
            let element = document.querySelector('.tipo'+item.id)
            element.classList.remove('colorbase')
            element.classList.add('colorSeleccionado')
            let formData = new FormData();
            formData.append('id_evaluacion',this.setEvaluacion.id);
            formData.append('id_intento',   this.evaluacionEstudiante.id_evaluacion_estudiante);
            formData.append('id_estudiante',this.evaluacionEstudiante.id_estudiante);
            formData.append('id_pregunta',  item.id);
            formData.append('respuesta',    tr.respuesta);
            formData.append('id_respuesta', tr.id);
            formData.append('estadoPregunta','1')
            this.$http.post(this.$server_url+'evaluacionEstudiante', formData)
            .then(res => {
                if(res.data.status == 0){
                    this.$vs.notify({
                        title: 'Error',
                        text: res.data.message,
                        color: 'danger',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle'
                    })
                }
            })
        },
        openConfirmFinalizar(){
            this.$vs.dialog({
                type: 'confirm',
                color: 'primary',
                title: 'Finalizar Evaluación',
                text: '¿Está seguro de finalizar la evaluación?',
                acceptText: 'Aceptar',
                accept: this.finalizarEvaluacion,
                cancelText: 'Cancelar',
                cancel: false
            })
        },
        finalizarEvaluacion(){
            let me = this
            let formData = new FormData();
            //preguntas abiertas
            let arrayPreguntasAbiertas = []
            arrayPreguntasAbiertas                  = this.arrayQuestions.filter(item => item.id_tipo == this.idPreguntaAbierta)
            formData.append('arrayPreguntasA',      JSON.stringify(arrayPreguntasAbiertas))
            formData.append('id_evaluacion',        this.setEvaluacion.id);
            formData.append('id_intento',           this.evaluacionEstudiante.id_evaluacion_estudiante);
            formData.append('id_estudiante',        this.evaluacionEstudiante.id_estudiante);
            formData.append('finalizarEvaluacion',  '1')
            this.$http.post(this.$server_url+'evaluacionEstudiante', formData)
            .then(res => {
                if(res.data.status == 0){
                    this.$vs.notify({
                        title: 'Error',
                        text: res.data.message,
                        color: 'danger',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle'
                    })
                    return 
                }
                if(res.data.status == 500){
                    this.$vs.notify({
                        title: 'Error',
                        text: 'Error al finalizar la evaluación',
                        color: 'danger',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle'
                    })
                    return
                }
                me.$emit('changeResponse',res.data)
                // this.$router.push('/estudiante/evaluaciones')
            })
            .catch(err => {
                this.$vs.notify({
                    title: 'Error',
                    text: 'Error al finalizar la evaluación',
                    color: 'danger',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle'
                })
            })
        },
        ejecutar() {
            let me = this;
            this.fecha = me.evaluacionEstudiante.fecha_limite;
            var countDownDate = new Date(this.fecha).getTime();

            // Si ya hay un intervalo corriendo, se limpia antes de crear uno nuevo
            if (this.intervalId) {
                clearInterval(this.intervalId);
                // Limpiar la referencia al intervalo
                this.intervalId = null;
                //limpiar el reloj
                document.getElementById("demo").innerHTML = "";
                //limpiar la hora minutos y segundos
            }

            // Actualizar la cuenta atrás cada 1 segundo
            this.intervalId = setInterval(function() {
                // Obtener la fecha y hora actuales
                var now = new Date().getTime();
                // Encontrar la distancia entre ahora y la fecha de cuenta atrás
                var distance = countDownDate - now;

                // Cálculos de tiempo para días, horas, minutos y segundos
                var days = Math.floor(distance / (1000 * 60 * 60 * 24));
                var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
                var seconds = Math.floor((distance % (1000 * 60)) / 1000);

                // Verificar si el elemento con id="demo" existe
                var demoElement = document.getElementById("demo");
                //si demoElement es nulo borrar el intervalo y cerrar el relo
                if(demoElement == null){
                    clearInterval(me.intervalId);
                    me.intervalId = null; // Limpiar la referencia al intervalo
                    return
                }
                if (demoElement) {

                    // Mostrar el resultado en el elemento
                    if (hours == 0) {
                        demoElement.innerHTML = 'Finaliza en ' + minutes + "m " + seconds + "s ";
                        // console.log("dos",demoElement.innerHTML = 'Finaliza en ' + minutes + "m " + seconds + "s ")
                    } else {
                        demoElement.innerHTML = 'Finaliza en ' + hours + ' horas ' + minutes + "m " + seconds + "s ";
                        // console.log("dos",'Finaliza en ' + hours + ' horas ' + minutes + "m " + seconds + "s ")
                    }
                }

                // Avisos
                if (hours == 0 && minutes == 5 && seconds == 0) {
                    me.$vs.notify({
                        title: 'Aviso',
                        text: 'Quedan ' + minutes + ' minutos para finalizar la evaluación',
                        color: 'warning',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle'
                    });
                }
                if (hours == 0 && minutes == 2 && seconds == 0) {
                    me.$vs.notify({
                        title: 'Aviso',
                        text: 'Quedan ' + minutes + ' minutos para finalizar la evaluación',
                        color: 'warning',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle'
                    });
                }
                if (hours == 0 && minutes == 1 && seconds == 0) {
                    me.$vs.notify({
                        title: 'Aviso',
                        text: 'Queda ' + minutes + ' minuto para finalizar la evaluación',
                        color: 'warning',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle'
                    });
                }
                if (hours == 0 && minutes == 0 && seconds == 10) {
                    me.$vs.notify({
                        title: 'Aviso',
                        text: 'Quedan ' + seconds + ' segundos para finalizar la evaluación',
                        color: 'warning',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle'
                    });
                }

                // Si la cuenta atrás ha terminado, limpiar el intervalo y actualizar la interfaz
                if (distance < 0) {
                    clearInterval(me.intervalId);
                    me.intervalId = null; // Limpiar la referencia al intervalo
                    if (demoElement) {
                        demoElement.innerHTML = "Se terminó el tiempo de la evaluación";
                    }
                    $('.boton').css('display', 'block');
                    me.finalizarEvaluacion();
                }
            }, 1000);
        }
    }
}
</script>
<style scoped>
.color1{
    color:#2F68AD;
}
.titulo{
    font-size: 18px;
    color:#19467c;
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    font-weight: 600;
}
.tamanio1{
    font-size: 11px;
}
.bg1{
    background: #f1f2f3;
    padding: 8px;
}
.reloj{
    font-size: 16px;
    color: #2F68AD;
    text-shadow: #e3e5e7 1px 1px 1px;
    padding: 5px;
}
.colorbase{
    background: #f2f2f2;
    border: none;
    padding: 10px;
    border-radius: 10px;

}
.colorSeleccionado{
    background: #cc4d27;
    color:white;
    border: none;
    padding: 10px;
    border-radius: 10px;
}
.colorSeleccionado:hover{
    background: #ca6546;
    color:white;
    border: none;
    padding: 10px;
    border-radius: 10px;
}
</style>
